<template>
  <el-dialog
    width="65%"
    title="Duplication Check List"
    :visible.sync="checkDialog"
    :show-close="false"
    :close-on-click-modal="false"
    :before-close="confirm"
  >
    <el-table
      height="400"
      border
      style="width: 100%"
      :header-cell-style="function({row, column, rowIndex, columnIndex}) {
          if (columnIndex < 2) {
            return {background: 'PaleTurquoise'}
          } else {
            return {background: 'PaleGreen'};
          }
      }"
      :data="data"
    >
      <el-table-column
        property="orderID"
        width="50"
        label="S/N"
      ></el-table-column>
      <el-table-column
        property="componentName"
        label="Component Name"
      ></el-table-column>
      <el-table-column
        property="cmpPlanName"
        label="Plan Name"
      ></el-table-column>
      <el-table-column
        property="cmpOrderID"
        width="50"
        label="S/N"
      ></el-table-column>
      <el-table-column
        property="cmpComponentName"
        label="Component Name"
      ></el-table-column>
      <el-table-column
        property="dupMonths"
        label="Months"
      ></el-table-column>
    </el-table>
    <div
      slot="footer"
      class="dialog-footer"
    >
      <el-button
        type="primary"
        @click="cancel"
      >Cancel</el-button>
      <el-button
        type="primary"
        @click="confirm"
      >Confirm</el-button>
    </div>
  </el-dialog>
</template>

><script>
export default {
  name: "CheckList",
  props: {
    result: {
      type: Boolean
    },
    data: {
      type: Array,
      default: function () {
        return [];
      }
    }
  },
  data () {
    return {
      checkDialog: this.result
    };
  },
  watch: {
    result (val) {
      this.checkDialog = val;
    }
  },
  methods: {
    cancel () {
      this.$emit("cancel", false);
    },
    confirm () {
      this.$emit("dialogData", false);
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/CheckList/index.vue